// Cliente API para comunicarse con el backend
// En localhost usar el mismo host en el puerto del backend; si no, usar variable de entorno o IP por defecto
import { logger } from "../hooks/Logger";
import { safeStorage } from "./safeStorage";

const getDefaultApiUrl = () => {
	if (
		typeof window !== "undefined" &&
		window.location?.hostname === "localhost"
	) {
		return "http://localhost:3001/api";
	}
	return process.env.REACT_APP_API_URL || "http://192.168.1.40:3001/api";
};
const API_BASE_URL = getDefaultApiUrl();
/*"http://localhost:3001/api" ||
	process.env.REACT_APP_API_URL ||
	getDefaultApiUrl();*/

/** Origen del API (ej. http://localhost:3001) para saber si una URL de imagen es del servidor */
export const getApiOrigin = () => {
	try {
		return new URL(API_BASE_URL).origin;
	} catch {
		return "http://localhost:3001";
	}
};

class ApiClient {
	constructor() {
		this.baseURL = API_BASE_URL;
		this.token = safeStorage.getItem("token");
	}

	setToken(token) {
		this.token = token;
		if (token) {
			safeStorage.setItem("token", token);
		} else {
			safeStorage.removeItem("token");
		}
	}

	getHeaders() {
		const headers = {
			"Content-Type": "application/json",
		};
		if (this.token) {
			headers["Authorization"] = `Bearer ${this.token}`;
		}
		return headers;
	}

	getHeadersForFormData() {
		const headers = {};
		if (this.token) {
			headers["Authorization"] = `Bearer ${this.token}`;
		}
		return headers;
	}

	async request(endpoint, options = {}) {
		const url = `${this.baseURL}${endpoint}`;
		const config = {
			...options,
			credentials: "include", // para que el backend pueda setear cookie y las peticiones la envíen
			headers: options.headers || this.getHeaders(),
		};

		try {
			const response = await fetch(url, config);
			let data;
			try {
				data = await response.json();
			} catch (parseErr) {
				// Respuesta no es JSON (ej. HTML de error del servidor)
				data = { error: response.statusText || "Error del servidor" };
			}

			if (!response.ok) {
				const error = new Error(
					data.message || data.error || `Error: ${response.statusText}`,
				);
				error.status = response.status;
				error.response = { status: response.status, data };
				error.statusText = response.statusText;
				throw error;
			}

			return data;
		} catch (error) {
			// Asegurar que errores de red tengan algo que el Viewer pueda usar
			if (
				error.status === undefined &&
				error.name === "TypeError" &&
				error.message.includes("fetch")
			) {
				error.status = 0;
			}
			logger.error("API Error", {
				endpoint,
				method: options.method || "GET",
				status: error.status,
				message: error.message,
			});
			throw error;
		}
	}

	async get(endpoint) {
		return this.request(endpoint, { method: "GET" });
	}

	async post(endpoint, data) {
		return this.request(endpoint, {
			method: "POST",
			body: JSON.stringify(data),
		});
	}

	async put(endpoint, data) {
		return this.request(endpoint, {
			method: "PUT",
			body: JSON.stringify(data),
		});
	}

	async patch(endpoint, data) {
		return this.request(endpoint, {
			method: "PATCH",
			body: JSON.stringify(data),
		});
	}

	async delete(endpoint) {
		return this.request(endpoint, { method: "DELETE" });
	}

	async uploadFile(endpoint, file) {
		const formData = new FormData();
		formData.append("image", file);

		const url = `${this.baseURL}${endpoint}`;
		const headers = this.getHeadersForFormData();

		try {
			const response = await fetch(url, {
				method: "POST",
				credentials: "include",
				headers,
				body: formData,
			});

			const data = await response.json();

			if (!response.ok) {
				throw new Error(data.error || `Error: ${response.statusText}`);
			}

			return data;
		} catch (error) {
			logger.error("Upload Error", {
				endpoint,
				message: error.message,
			});
			throw error;
		}
	}
}

export default new ApiClient();
